import { Injectable } from '@angular/core';
import { FlyoutFooter } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  checkStringValueNull,
  getAuxiliaryNavigation,
  HeaderFooterMachCore,
  MY_FLIGHT_PANEL,
  MyFlightPanelAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Injectable({
  providedIn: 'root'
})
export class FlyoutFooterAdapterService {
  getContent(contentHeaderFooter: HeaderFooterMachCore): FlyoutFooter {
    const myFlightPanel = getAuxiliaryNavigation(
      contentHeaderFooter,
      MY_FLIGHT_PANEL
    ) as MyFlightPanelAem;

    return {
      myTripLabel: checkStringValueNull(myFlightPanel?.dashboardLabel),
      profileLabel: checkStringValueNull(myFlightPanel?.profileLabel),
      mySkyMilesLabel: checkStringValueNull(myFlightPanel?.mySkyMilesLabel),
      LogOutLabel: checkStringValueNull(myFlightPanel?.logoutLabel),
      myTripLink: checkStringValueNull(myFlightPanel?.dashboardUrl),
      profileLink: checkStringValueNull(myFlightPanel?.profileUrl),
      mySkyMilesLink: checkStringValueNull(myFlightPanel?.newMySkyMilesUrl)
    };
  }
}
